import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal';
import GatingMessage from './GatingMessage';
import { getTranslation } from '../../providers/TranslationProvider';

export const GatingMessageModal = (props) => {
  const addCreditCardLabel = getTranslation({
    translationKey: 'add_credit_card',
    fallback: 'Add Credit Card',
  });
  const { closeModal } = props;
  return (
    <Modal
      isOpen
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      onRequestClose={closeModal}
      styles={{ content: { maxWidth: '660px', padding: '0px' } }}
      aria={{
        label: addCreditCardLabel,
      }}
    >
      <GatingMessage {...props} />
    </Modal>
  );
};

GatingMessageModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export { GatingMessageModal as ComponentUnderTest };
export default GatingMessageModal;
